var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import iconTypes from './IconTypes';
const IconWrapper = styled.button `
  display: inline-block;
  padding: 0;
  margin: 0;
  cursor: pointer;  
  height: ${(props) => props.size + 5}px;
  width: ${(props) => props.size + 5}px;
  border-radius: 50%;
  border: 0;
  background-color: inherit;
  display:flex;
  align-items: center;
  justify-content: center;
  &:hover, &:focus {
    background-color: #e6e6e6;
  }
`;
const Icon = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.size - 5}px;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
`;
const IconButton = (_a) => {
    var { iconType, icon, onClick } = _a, props = __rest(_a, ["iconType", "icon", "onClick"]);
    return (React.createElement(IconWrapper, Object.assign({ onClick: onClick }, props),
        React.createElement(Icon, { size: props.size }, icon ? (icon) : iconType && React.createElement(FontAwesomeIcon, { icon: iconTypes[iconType] }))));
};
export default IconButton;
